import { Component, Input, OnInit } from '@angular/core';
import { Dictionary } from 'lodash';
import { takeUntil } from 'rxjs';
import { Destroyer } from 'src/app/core/abstract/destroyer';
import { CustomField, CustomFieldOption } from 'src/app/core/models/custom-fields.models';
import { Idea, IdeaCustomFieldValue } from 'src/app/core/models/idea.models';
import { CustomFieldsStoreService } from 'src/app/core/store/services/custom-fields-store.service';

@Component({
  selector: 'craft-idea-custom-list',
  templateUrl: './idea-custom-list.component.html',
  styleUrls: ['./idea-custom-list.component.scss'],
  standalone: false,
})
export class IdeaCustomListComponent extends Destroyer implements OnInit {
  @Input() public idea: Readonly<Idea>;
  @Input() public maxFieldsSize: number;

  public fieldsMap: Dictionary<CustomField>;
  public optionsMap: Dictionary<CustomFieldOption>;

  constructor(private customFieldsStore: CustomFieldsStoreService) {
    super();
  }

  public ngOnInit(): void {
    this.customFieldsStore.map$.pipe(takeUntil(this.destroy$)).subscribe((map) => {
      this.fieldsMap = map;
    });
    this.customFieldsStore.optionsMap$.pipe(takeUntil(this.destroy$)).subscribe((map) => {
      this.optionsMap = map;
    });
  }

  public identify(index: number, item?: IdeaCustomFieldValue): string | number {
    return item?.id || index;
  }
}
